var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui container"},[_c('div',{staticClass:"ui column grid centered"},[_c('div',{staticClass:"four wide column"},[_c('div',{staticClass:"wrapper-authenticate"},[_c('h1',[_vm._v("Login")]),_c('t-form-login')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }